var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "over-heigth" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.pageLoading,
              expression: "pageLoading",
            },
          ],
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v("第" + _vm._s(_vm.day) + "天-經過點設定")]),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", padding: "6px 15px" },
                  attrs: { type: "success" },
                  on: { click: _vm.passPointSave },
                },
                [_vm._v("儲存")]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { inline: true, size: "mini" },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.addNew },
                        },
                        [_vm._v("新增")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.list, function (item, index) {
                return _c(
                  "el-form",
                  {
                    key: index,
                    staticClass: "demo-form-inline",
                    attrs: { inline: true, size: "mini" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "", size: "mini" } },
                      [_c("el-tag", [_vm._v(_vm._s(index + 1))])],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "區域", size: "mini" } },
                      [
                        item.regions
                          ? _c(
                              "el-select",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.pageLoading,
                                    expression: "pageLoading",
                                  },
                                ],
                                staticStyle: { width: "100px" },
                                attrs: {
                                  "value-key": "key",
                                  placeholder: "區域",
                                  size: "mini",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.selectedRegion(item)
                                  },
                                },
                                model: {
                                  value: item.region,
                                  callback: function ($$v) {
                                    _vm.$set(item, "region", $$v)
                                  },
                                  expression: "item.region",
                                },
                              },
                              _vm._l(item.regions, function (c, ind) {
                                return _c("el-option", {
                                  key: ind,
                                  attrs: { label: c.val, value: c.key },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "國家", size: "mini" } },
                      [
                        item.countries
                          ? _c(
                              "el-select",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: item.countriesLoading,
                                    expression: "item.countriesLoading",
                                  },
                                ],
                                staticStyle: { width: "100px" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "國家",
                                  "value-key": "code",
                                  size: "mini",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.selectedCountry(item)
                                  },
                                },
                                model: {
                                  value: item.country,
                                  callback: function ($$v) {
                                    _vm.$set(item, "country", $$v)
                                  },
                                  expression: "item.country",
                                },
                              },
                              _vm._l(item.countries, function (c, ind) {
                                return _c("el-option", {
                                  key: ind,
                                  attrs: { label: c.chtName, value: c },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "城市", size: "mini" } },
                      [
                        item.cities
                          ? _c(
                              "el-select",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value:
                                      item.countriesLoading ||
                                      item.citiesLoading,
                                    expression:
                                      "item.countriesLoading || item.citiesLoading",
                                  },
                                ],
                                staticStyle: { width: "120px" },
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "城市",
                                  "value-key": "code",
                                  size: "mini",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.selectedCity(item)
                                  },
                                },
                                model: {
                                  value: item.city,
                                  callback: function ($$v) {
                                    _vm.$set(item, "city", $$v)
                                  },
                                  expression: "item.city",
                                },
                              },
                              _vm._l(item.cities, function (c, ind) {
                                return _c("el-option", {
                                  key: ind,
                                  attrs: { label: c.chtName, value: c },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { display: "none" },
                        attrs: { label: "經緯度(lng,lat)" },
                      },
                      [
                        _c(
                          "el-col",
                          { staticClass: "line", attrs: { span: 12 } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "經度(lng)" },
                              model: {
                                value: item.lng,
                                callback: function ($$v) {
                                  _vm.$set(item, "lng", $$v)
                                },
                                expression: "item.lng",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { staticClass: "line", attrs: { span: 12 } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "緯度(lat)" },
                              model: {
                                value: item.lat,
                                callback: function ($$v) {
                                  _vm.$set(item, "lat", $$v)
                                },
                                expression: "item.lat",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteData(item)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }